import React, { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell, LabelList } from "recharts";
import api, { formatMoney, formatNumber } from "../lib/api";

export function RankingParadoEmpleados({ rows }) {
  const [names, setNames] = useState({});
  useEffect(() => { api.get("/staff").then((r) => setNames(Object.fromEntries((r.data.personal || []).map((s) => [s.vendedor, s.nombre])))).catch(() => {}); }, []);
  const total = (rows || []).reduce((t, e) => t + (e.stock_parado_eur || 0), 0);
  const data = (rows || []).filter((e) => (e.stock_parado_eur || 0) > 0)
    .map((e) => ({ nombre: names[e.vendedor] || e.vendedor, eur: e.stock_parado_eur, uds: e.stock_parado_uds, pct: total ? (100 * e.stock_parado_eur) / total : 0,
                   peso: e.facturacion ? (100 * e.stock_parado_eur) / e.facturacion : null }))
    .sort((a, b) => b.eur - a.eur);
  if (!data.length) return null;
  const conUds = data.some((d) => d.uds != null);
  return (
    <div className="mb-5 rounded-xl border border-slate-200 p-4" data-testid="dead-stock-empleados">
      <div className="flex items-baseline justify-between flex-wrap gap-2 mb-2">
        <h4 className="font-display font-bold">¿Quién vende el stock parado?</h4>
        <span className="text-xs text-slate-500">Facturación de productos D por empleado · total {formatMoney(total)}</span>
      </div>
      <div className="grid lg:grid-cols-2 gap-4 items-start">
        <ResponsiveContainer width="100%" height={Math.max(140, data.length * 30)}>
          <BarChart data={data} layout="vertical" margin={{ left: 8, right: 48 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" horizontal={false} />
            <XAxis type="number" tick={{ fontSize: 10 }} tickFormatter={(v) => formatMoney(v)} />
            <YAxis type="category" dataKey="nombre" width={120} tick={{ fontSize: 11 }} />
            <Tooltip formatter={(v, n, it) => [`${formatMoney(v)}${it.payload.uds != null ? ` · ${formatNumber(it.payload.uds)} uds` : ""} · ${it.payload.pct.toFixed(1).replace(".", ",")} % del total`, "Stock D vendido"]} />
            <Bar dataKey="eur" radius={[0, 4, 4, 0]}>
              {data.map((d, i) => <Cell key={d.nombre} fill={i === 0 ? "#059669" : i < 3 ? "#10b981" : "#94a3b8"} />)}
              <LabelList dataKey="pct" position="right" formatter={(v) => `${v.toFixed(0)} %`} style={{ fontSize: 10, fill: "#334155", fontWeight: 700 }} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
        <table className="dense text-[11px]" data-testid="dead-stock-empleados-tabla">
          <thead><tr><th>#</th><th>Empleado</th><th className="num">Stock D vendido</th>{conUds && <th className="num">Uds</th>}<th className="num">% del total</th><th className="num">% de su venta</th></tr></thead>
          <tbody>
            {data.map((d, i) => (
              <tr key={d.nombre}>
                <td>{i + 1}</td><td className="font-semibold">{d.nombre}</td><td className="num">{formatMoney(d.eur)}</td>
                {conUds && <td className="num">{d.uds != null ? formatNumber(d.uds) : "—"}</td>}
                <td className="num">{d.pct.toFixed(1).replace(".", ",")} %</td>
                <td className="num">{d.peso != null ? `${d.peso.toFixed(1).replace(".", ",")} %` : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
